import requests from "./httpService";

// Identical list requests made at the same moment (the Tasks page and the Sidebar both ask for
// Due Today on load) share one request instead of each hitting the server
const inFlight = new Map();
const sharedGet = (url) => {
  if (!inFlight.has(url)) {
    inFlight.set(url, requests.get(url).finally(() => inFlight.delete(url)));
  }
  return inFlight.get(url);
};

const TaskServices = {
  // waitFresh: the server answers task lists from a cache and marks changed data `stale: true`;
  // asking with wait_fresh=1 waits for the rebuilt answer instead
  getAllTask(id, params = {}) {
    const { skipTasks, excludeComplete, waitFresh } = params;
    let url = `/tasks/all?company_id=${id}`;
    if (skipTasks) url += `&skipTasks=true`;
    if (excludeComplete) url += `&exclude_complete=true`;
    if (waitFresh) url += `&wait_fresh=1`;
    return sharedGet(url);
  },
  getDueTodayTask(id, { waitFresh } = {}) {
    return sharedGet(`/tasks/duetoday?company_id=${id}${waitFresh ? "&wait_fresh=1" : ""}`);
  },
  getCriticalTasksForUser(companyId, userId) {
    return requests.get(`/tasks/critical-for-user?company_id=${companyId}&user_id=${userId}`);
  },
  getTasksByFilter(id, filter, { page, limit, waitFresh } = {}) {
    let url = `/tasks/filter?company_id=${id}&filter=${filter}`;
    if (limit) url += `&limit=${limit}&page=${page || 1}`;
    if (waitFresh) url += `&wait_fresh=1`;
    return requests.get(url);
  },
  updateTasksTitle(id, body) {
    return requests.post(`/update-task-title/${id}`, body);
  },
  updateTaskAssigne(id, body) {
    return requests.post(`/tasks/updateasignedto/${id}`, body);
  },
  updateTaskStatus(id, body) {
    return requests.post(`/tasks/updatetaskstatus/${id}`, body);
  },
  createTask(body) {
    return requests.post(`/tasks/create`, body);
  },
  updateTask(id, body) {
    return requests.post(`/tasks/update/${id}`, body);
  },
  viewTask(id, body) {
    return requests.post(`/tasks/view/${id}`, body);
  },
  delTask(id, body) {
    return requests.delete(`/tasks/${id}`, body);
  },
  addTaskNote(id, body, headers) {
    return requests.post(`/tasks/addnote/${id}`, body, headers);
  },
  showTaskNote(id, body) {
    return requests.post(`/tasks/showtasknote/${id}`, body);
  },
  createSubTask(id, body) {
    return requests.post(`/tasks/createsubtask/${id}`, body);
  },
  pinToTop(id, body) {
    return requests.post(`/tasks/updatenotepin/${id}`, body);
  },
  noteUpdate(id, body) {
    return requests.post(`/tasks/updatenote/${id}`, body);
  },
  deleteTask(id, body) {
    return requests.get(`/tasks/${id}`, body);
  },
  deleteTaskNote(id, body) {
    return requests.post(`/tasks/deletenote/${id}`, body);
  },
  createTaskAttatchment(id, body, headers) {
    return requests.post(`/tasks/attachments/${id}`, body, headers);
  },
  updateTaskDueDate(id, body) {
    return requests.post(`/tasks/updatetaskduedate/${id}`, body);
  },

  deleteTaskAttachment(id, body) {
    return requests.post(`/tasks/attachmentdelete/${id}`, body);
  },
  updateNoteReaction(id, body) {
    return requests.post(`/tasks/updatenotereaction/${id}`, body);
  },
  updateTaskProject(id, body) {
    return requests.post(`/tasks/updatetaskproject/${id}`, body);
  },
  rejectTask(id, body) {
    return requests.post(`/tasks/reject/${id}`, body);
  },
  approveTask(id, body) {
    return requests.post(`/tasks/approve/${id}`, body);
  },
  recalculateSchedule(id, body) {
    return requests.post(`/tasks/recalculate/${id}`, body);
  },
  getDependencies(taskId, companyId) {
    return requests.get(`/tasks/dependencies/${taskId}?company_id=${companyId}`);
  },
  addDependency(body) {
    return requests.post(`/tasks/dependencies/add`, body);
  },
  removeDependency(body) {
    return requests.post(`/tasks/dependencies/remove`, body);
  },
  reorderCritical(body) {
    return requests.post(`/tasks/reorder-critical`, body);
  },
  rescheduleReopened(id, body) {
    return requests.post(`/tasks/reschedule-reopened/${id}`, body);
  },
  reopenTask(id, body) {
    return requests.post(`/tasks/reopen/${id}`, body);
  },
  extendDelayedTask(id, body) {
    return requests.post(`/tasks/extend-delayed/${id}`, body);
  },
  // Tasks that should show the "task is now delayed" popup to the logged-in user (decided on the server)
  getDelayedPopupTasks(company_id) {
    return requests.get(`/tasks/delayed-popup?company_id=${company_id}`);
  },
  migratePriorities(company_id) {
    return requests.post(`/tasks/migrate-priorities`, { company_id });
  },
  migrateEffortToMinutes(company_id) {
    return requests.post(`/tasks/migrate-effort-to-minutes`, { company_id });
  },

};
export default TaskServices;
